import { availabilityAskingRentRules } from './asking-rent.calc.js';
import { availabilityAskingRentMatrixRules } from './asking-rent-matrix.calc.js';
import { availabilityMinDivisibleRules } from './min-divisible.calc.js';
import { availabilityRateRules } from './rates.calc.js';
import { availabilityServiceChargeRules } from './service-charge.calc.js';
export const availabilityRules = [...availabilityRateRules, ...availabilityAskingRentRules, ...availabilityAskingRentMatrixRules, ...availabilityServiceChargeRules, ...availabilityMinDivisibleRules];
export const availabilityRegistry = {
  domain: 'availability',
  rules: availabilityRules
};
